import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

export function useOnline() {
  const [on, setOn] = useState(navigator.onLine);
  useEffect(() => {
    const up = () => setOn(true);
    const down = () => setOn(false);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    return () => { window.removeEventListener("online", up); window.removeEventListener("offline", down); };
  }, []);
  return on;
}

export function OfflineBanner({ dark, note }) {
  const on = useOnline();
  if (on) return null;
  return (
    <div data-testid="offline-banner" className={`flex items-center justify-center gap-2 px-4 py-2 text-sm font-semibold ${dark ? "bg-amber-500 text-slate-900" : "bg-stone-900 text-white"}`}>
      <WifiOff className="h-4 w-4" /> You're offline. {note || "Showing the last saved data; changes will sync when you're back."}
    </div>
  );
}
